import { create } from "zustand";

interface MainGroupSelectorSlice {
    mainGroupId: string | undefined;
    setMainGroupId: (id: string | undefined) => void;
}

export const useMainGroupSelectorStore = create<MainGroupSelectorSlice>(
    (set) => ({
        mainGroupId: undefined,
        setMainGroupId: (id) => set({ mainGroupId: id }),
    }),
);
